export default __webpack_public_path__ + "static/media/create_enc2.261d3dd3.PNG";